<template>
    <footer id="footer">
        <div class="container">
            <div class="slide">
                <Widget position="slide" />
<!--                <img src="@/assets//img/slide/1.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/2.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/3.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/8.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/9.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/4.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/6.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/7.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/8.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/5.jpg" alt="">-->
<!--                <img src="@/assets//img/slide/9.jpg" alt="">-->
            </div>
            <div class="footer-nav">
                <div class="f-nav">
                    <Widget position="footer_menu_1" />
<!--                    <ul>-->
<!--                        <li><a href="#">Воздух</a></li>-->
<!--                        <li><a href="#">Изменение климата</a></li>-->
<!--                        <li><a href="#">Водные ресурсы</a></li>-->
<!--                        <li><a href="#">Биоразнообразие</a></li>-->
<!--                    </ul>-->
                </div>
                <div class="f-nav">
                    <Widget position="footer_menu_2" />

                    <!--                    <ul>-->
<!--                        <li><a href="#">Зесмельные ресурсы</a></li>-->
<!--                        <li><a href="#">Сельское хозяйство</a></li>-->
<!--                        <li><a href="#">Энергетика</a></li>-->
<!--                        <li><a href="#">Транспорт</a></li>-->
<!--                    </ul>-->
                </div>
                <div class="f-nav">
                    <Widget position="footer_menu_3" />

                    <!--                    <ul>-->
<!--                        <li><a href="#">Отходы</a></li>-->
<!--                        <li><a href="#">Охрана ОС</a></li>-->
<!--                        <li><a href="#">Контакты</a></li>-->
<!--                        <li><a href="#">Аналитика</a></li>-->
<!--                    </ul>-->
                </div>
                <div class="f-nav">
                    <Widget position="footer_menu_4" />

                    <!--                    <a href="#">Нацдоклад в формате .pdf</a>-->
                </div>
            </div>
            <div class="copiright">
                <Widget position="copyright" />
                <!--                <p><img src="@/assets/img/partners/unep.png" alt="ЮНЕП">Разработано при финансовой поддержки ЮНЕП</p>-->
<!--                <p>© Государственное Агенство охраны среды и лесного хозяйства при Правительсве Кыргызской Республики</p>-->
            </div>
        </div>
    </footer>
</template>

<script>
    import Widget from "@/components/app/Widget";

    export default {
        name: "Footer",
        components: {
            Widget
        }
    }
</script>

<style scoped>

</style>
